import {createApp} from 'vue'
import {createPinia} from 'pinia'
import '@pointboard/shared/styles'
import {useAuthenticationStore} from './stores'
import '@fortawesome/fontawesome-pro/css/all.min.css'
import 'clipboard'
import App from './App.vue'
import router from './router/routes'
import 'bootstrap'
import FloatingVue from 'floating-vue'
import Notifications from '@kyvg/vue3-notification'
import {register} from 'swiper/element/bundle'
import {setupSentry} from '@shared/integrations/sentry/sentry'

const pinia = createPinia()
const app = createApp(App)

register()
setupSentry(app, {router})

app.use(pinia)
app.use(router)
app.use(FloatingVue)
app.use(Notifications)
app.mount('#app')

export const authenticationStore = useAuthenticationStore()
export const mainRouter = router
